const Site = (function () {
    /**
     * Checks if the current site is has correct domain and directory.
     * @returns {boolean} True if the current site criteria is correct, false otherwise.
     */
    const isValidSite = function (domains, siteDirectory) {
        const hasDirectory = (url, directory) => {
            const regex = new RegExp(`/${directory}/`);
            return regex.test(url);
        };

        const url = window.location.hostname;
        const domainExtension = url.match(/\.[^.]+$/)?.[0] ?? '';

        return domainExtension === domains && hasDirectory(document.location.href, siteDirectory);
    };

    return {
        isValidSite,
    };
})();

export default Site;
